import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TopTrending.css";

export default function TopTrending() {
  const items = [
    {
      number: "01",
      name: "Stake",
      image: "/GSSTAKE.png?w=800&auto=format&fit=crop"
    },
    {
      number: "02",
      name: "BC Game",
      image: "/GSBCGAMES.png?w=800&auto=format&fit=crop"
    },
    {
      number: "03",
      name: "Diamond Exchange",
      image: "/GSDIAMONDEXCHANGE.png?w=800&auto=format&fit=crop"
    },
    {
      number: "04",
      name: "Reddy Anna",
      image: "/GSREDDYANNA.png?w=800&auto=format&fit=crop"
    },
    {
      number: "05",
      name: "BitcoinJito",
      image: "/GSBITCOINJITO.png?w=800&auto=format&fit=crop"
    },
    {
      number: "06",
      name: "Lotus Book",
      image: "/GSLOTUSBOOK.png?w=800&auto=format&fit=crop"
    }
  ];

  return (
    <section id="solutions" className="trending-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Trending</div>
          <h2 className="section-title">
            Top <span className="gradient-text">Trending Solutions</span>
          </h2>
        </div>

        <div className="trending-grid">
          {items.map((item, i) => (
            <div key={i} className="trending-card" data-index={i}>
              <div className="trending-image-wrapper">
                <img src={item.image} className="trending-image" alt={item.name}/>
                <div className="image-overlay"></div>
                <div className="card-number-badge">{item.number}</div>
              </div>
              
              <div className="trending-content">
                <h4 className="trending-name">{item.name}</h4>
                
                <div className="card-arrow">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M5 14L14 5M14 5H5M14 5V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>

              <div className="card-shimmer"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
